import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';

/**
 * Authority/E-E-A-T signal shown on articles and program pages.
 * Links the reviewer to their profile and to the editorial policy.
 */
export const MedicalReviewByline = ({ reviewer = 'Dr. Pooja Sree', credentials = 'MBBS, DNB General Medicine', className = '' }) => (
  <div
    className={`inline-flex items-center gap-2.5 rounded-xl border border-emerald-500/25 bg-emerald-500/5 px-3.5 py-2 ${className}`}
    data-testid="medical-review-byline"
  >
    <ShieldCheck className="w-4 h-4 text-emerald-400 flex-shrink-0" aria-hidden="true" />
    <span className="text-xs sm:text-sm text-slate-300">
      Medically reviewed by{' '}
      <Link to="/author/dr-pooja-sree" className="text-white font-semibold hover:underline underline-offset-2" data-testid="byline-author-link">{reviewer}</Link>
      <span className="text-slate-400"> ({credentials})</span>
      <span className="text-slate-600 mx-1.5" aria-hidden="true">·</span>
      <Link to="/editorial-policy" className="text-emerald-400 hover:underline underline-offset-2" data-testid="byline-policy-link">Review policy</Link>
    </span>
  </div>
);

export default MedicalReviewByline;
